import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@recruitee/analytics';

@Injectable()
export class NotesAnalytics extends AnalyticsBase {
  public readonly namespace = 'Note';
  public readonly requireViewContext = true;

  public trackNoteAdding(target: string) {
    this.track('AddNote', { target });
  }
}
